import { useNavigate } from 'react-router-dom'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center bg-gray-50">
      <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-gray-800">
        الصفحة غير موجودة
      </h1>
      <p className="mb-8 text-gray-600 text-lg">
        عذراً، هذه الصفحة غير متوفرة أو قد تم حذفها.
      </p>
      <button
        onClick={() => navigate('/')}
        className="px-6 py-3 bg-blue-600 text-white rounded-md text-lg font-semibold hover:bg-blue-700 transition"
      >
        العودة إلى الموقع
      </button>
    </div>
  )
}
